var React = require('react');

function ArrowCurveUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M205.66 85.66a8 8 0 0 1-11.32 0L160 51.31V128A104.11 104.11 0 0 1 56 232a8 8 0 0 1 0-16 88.1 88.1 0 0 0 88-88V51.31l-34.34 34.35a8 8 0 0 1-11.32-11.32l48-48a8 8 0 0 1 11.32 0l48 48a8 8 0 0 1 0 11.32Z"}));
}

ArrowCurveUp.defaultProps = {"fill":"currentColor","aria-labelledby":"Arrow curve pointing up","viewBox":"0 0 256 256"};

module.exports = ArrowCurveUp;

ArrowCurveUp.default = ArrowCurveUp;
